import { minimize_str } from "@core/helpers/string";

// what the logged-in visitor has in a form (web-server getMyFormSubmission): their row - a draft, or the answer they sent - and the step they
// are on. `values` is the SENT answer as stored (a file is { media_id, url, name, size }); `progress` the values filled so far.
export const GET_MY_FORM_SUBMISSION = minimize_str(`
  query ($form_definition_id: ID, $form_key: String) {
   result: getMyFormSubmission(form_definition_id: $form_definition_id, form_key: $form_key) {
    id
    status
    version
    values
    edit_count
    review_status
    editable
    progress {
     step
     version
     values
     updatedAt
    }
    createdAt
    updatedAt
   }
  }
`);
